import { render, staticRenderFns, recyclableRender, components } from "./scancode.vue?vue&type=template&id=45a74fde&scoped=true&"
var renderjs
import script from "./scancode.vue?vue&type=script&lang=js&"
export * from "./scancode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a74fde",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/scancode.vue"
export default component.exports